<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";

export default {
    components: { Layout, PageHeader },
    data() {
        return {
            title: "Vía de admisión",
            items: [
                {
                    text: "Dashboard",
                    href: "/"
                },
                {
                    text: "Vía de admisión",
                    active: true
                }
            ],
            periodo: "",
            cargando: false,
            error: "",
            periodos: [],
            resumen: {
                matriculas: 0,
                conMencion: 0,
                conNotas: 0
            },
            filtros: {
                busqueda: "",
                carrera: "todas",
                aprobacion: "todas",
                mencion: "todas"
            },
            vias: []
        };
    },
    computed: {
        carrerasOptions() {
            return this.uniqueOptions(this.vias.map(row => row.carrera).filter(Boolean));
        },
        aprobacionOptions() {
            return [
                { value: "todas", label: "Todas" },
                { value: "con_nivelacion", label: "Con nivelación" },
                { value: "sin_nivelacion", label: "Sin nivelación" }
            ];
        },
        mencionOptions() {
            const options = this.uniqueOptions(this.vias
                .filter(row => row.mencion || row.mencion_campo)
                .map(row => row.mencion_campo || row.mencion));

            return [
                { value: "todas", label: "Todas" },
                { value: "con_mencion", label: "Cualquier mención" },
                ...options
            ];
        },
        viasFiltradas() {
            const busqueda = this.normalizeText(this.filtros.busqueda);

            return this.vias.filter(row => {
                const aprobacion = this.normalizeText(row.aprobacion);
                const mentionValue = row.mencion_campo || row.mencion;

                if (busqueda) {
                    const searchTarget = this.normalizeText([
                        row.dealname,
                        row.contact_name,
                        row.hubspot_id,
                        row.rut,
                        row.carrera,
                        row.aprobacion,
                        row.mencion,
                        row.mencion_campo
                    ].join(" "));

                    if (!searchTarget.includes(busqueda)) {
                        return false;
                    }
                }

                if (this.filtros.carrera !== "todas" && row.carrera !== this.filtros.carrera) {
                    return false;
                }

                if (this.filtros.aprobacion === "con_nivelacion" && !aprobacion.includes("con nivelacion")) {
                    return false;
                }

                if (this.filtros.aprobacion === "sin_nivelacion" && !aprobacion.includes("sin nivelacion")) {
                    return false;
                }

                if (this.filtros.mencion === "con_mencion" && !mentionValue) {
                    return false;
                }

                if (!['todas', 'con_mencion'].includes(this.filtros.mencion) && mentionValue !== this.filtros.mencion) {
                    return false;
                }

                return true;
            });
        },
        resumenFiltrado() {
            return {
                matriculas: this.viasFiltradas.length,
                conMencion: this.viasFiltradas.filter(row => row.mencion || row.mencion_campo).length,
                conNotas: this.viasFiltradas.filter(row => row.notas).length
            };
        }
    },
    mounted() {
        this.cargarDatos();
    },
    methods: {
        async cargarDatos() {
            this.cargando = true;
            this.error = "";

            try {
                const params = this.periodo ? { periodo: this.periodo } : {};
                const { data } = await axios.get("/api/dashboard/via-admision/advance", { params });

                this.periodo = data.periodo || this.periodo;
                this.periodos = Array.isArray(data.period_options) ? data.period_options : this.periodos;
                this.vias = Array.isArray(data.rows) ? data.rows.map(row => ({
                    hubspot_id: row.hubspot_id || "",
                    rut: row.rut || "",
                    contact_name: row.contact_name || "",
                    dealname: row.dealname || "Sin nombre",
                    periodo: row.periodo || "",
                    carrera: row.carrera || "Sin carrera",
                    aprobacion: row.aprobacion || "",
                    notas: row.notas || "",
                    mencion: row.mencion || "",
                    mencion_campo: row.mencion_campo || "",
                    closedate: row.closedate || ""
                })) : [];
                this.resumen = {
                    matriculas: Number(data.total || this.vias.length || 0),
                    conMencion: this.vias.filter(row => row.mencion).length,
                    conNotas: this.vias.filter(row => row.notas).length
                };
            } catch (error) {
                this.error = (error.response && error.response.data && error.response.data.message) || "No se pudo cargar la vía de admisión.";
            } finally {
                this.cargando = false;
            }
        },
        descargarCsv() {
            const headers = [
                "ID negocio",
                "RUT",
                "Nombre contacto",
                "Nombre negocio",
                "Período",
                "Carrera",
                "Aprobación Dir Carrera",
                "Notas Dir Carrera Advance",
                "Mención",
                "Campo mención",
                "Fecha matrícula"
            ];
            const rows = this.viasFiltradas.map(row => [
                row.hubspot_id,
                row.rut,
                row.contact_name,
                row.dealname,
                row.periodo,
                row.carrera,
                row.aprobacion,
                row.notas,
                row.mencion,
                row.mencion_campo,
                row.closedate
            ]);
            const csv = [headers, ...rows]
                .map(columns => columns.map(this.csvCell).join(","))
                .join("\n");
            const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `via-admision-advance-${this.periodo.replace(/\s+/g, "").replace(/[^0-9-]/g, "")}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
        },
        limpiarFiltros() {
            this.filtros = {
                busqueda: "",
                carrera: "todas",
                aprobacion: "todas",
                mencion: "todas"
            };
        },
        uniqueOptions(values) {
            return [...new Set(values)]
                .sort((a, b) => a.localeCompare(b, "es"))
                .map(value => ({ value, label: value }));
        },
        normalizeText(value) {
            return String(value || "")
                .normalize("NFD")
                .replace(/[\u0300-\u036f]/g, "")
                .toLowerCase()
                .replace(/\s+/g, " ")
                .trim();
        },
        csvCell(value) {
            return `"${String(value || "").replace(/"/g, '""')}"`;
        },
        formatNumber(value) {
            return Number(value || 0).toLocaleString("es-CL");
        },
        formatShortDate(value) {
            if (!value) {
                return "-";
            }

            return value;
        }
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div v-if="error" class="alert alert-danger">
            <i class="bx bx-error-circle mr-1"></i>
            {{ error }}
        </div>

        <div class="card admission-path-section border-0 shadow-sm mb-3">
            <div class="card-body">
                <div class="admission-path-header mb-3">
                    <div>
                        <h4 class="mb-1">Vía de admisión</h4>
                        <small class="text-muted">Admisiones Advance · Matriculados con aprobación Dirección de Carrera</small>
                    </div>
                    <div class="admission-path-filters">
                        <select v-model="periodo" class="custom-select custom-select-sm" :disabled="cargando" @change="cargarDatos">
                            <option v-for="option in periodos" :key="option" :value="option">{{ option }}</option>
                        </select>
                        <button type="button" class="btn btn-sm btn-primary" :disabled="cargando" @click="cargarDatos">
                            <i class="bx" :class="cargando ? 'bx-loader-alt bx-spin' : 'bx-refresh'"></i>
                            <span>{{ cargando ? 'Cargando' : 'Actualizar' }}</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-outline-primary" :disabled="cargando || !viasFiltradas.length" @click="descargarCsv">
                            <i class="bx bx-download"></i>
                            <span>CSV</span>
                        </button>
                    </div>
                </div>

                <div class="row admission-path-kpi-grid">
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="admission-path-kpi">
                            <span>Registros visibles</span>
                            <strong>{{ formatNumber(resumenFiltrado.matriculas) }}</strong>
                            <small class="text-muted">de {{ formatNumber(resumen.matriculas) }}</small>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="admission-path-kpi">
                            <span>Con mención</span>
                            <strong>{{ formatNumber(resumenFiltrado.conMencion) }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="admission-path-kpi admission-path-kpi-primary">
                            <span>Con notas</span>
                            <strong>{{ formatNumber(resumenFiltrado.conNotas) }}</strong>
                        </div>
                    </div>
                    <div class="col-md-6 col-xl-3 mb-3">
                        <div class="admission-path-kpi">
                            <span>Pipeline</span>
                            <strong>Advance</strong>
                        </div>
                    </div>
                </div>

                <div class="admission-path-filter-panel mb-3">
                    <div class="form-row">
                        <div class="col-md-4 col-xl-3 mb-2">
                            <label class="mb-1">Buscar contacto o RUT</label>
                            <input v-model="filtros.busqueda" type="search" class="form-control form-control-sm" placeholder="Contacto, negocio, ID, RUT...">
                        </div>
                        <div class="col-md-4 col-xl-3 mb-2">
                            <label class="mb-1">Carrera</label>
                            <select v-model="filtros.carrera" class="custom-select custom-select-sm">
                                <option value="todas">Todas</option>
                                <option v-for="option in carrerasOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                            </select>
                        </div>
                        <div class="col-md-4 col-xl-2 mb-2">
                            <label class="mb-1">Aprobación</label>
                            <select v-model="filtros.aprobacion" class="custom-select custom-select-sm">
                                <option v-for="option in aprobacionOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                            </select>
                        </div>
                        <div class="col-md-6 col-xl-3 mb-2">
                            <label class="mb-1">Mención</label>
                            <select v-model="filtros.mencion" class="custom-select custom-select-sm">
                                <option v-for="option in mencionOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                            </select>
                        </div>
                        <div class="col-md-6 col-xl-1 mb-2 admission-path-clear-filter">
                            <button type="button" class="btn btn-sm btn-light btn-block" @click="limpiarFiltros">Limpiar</button>
                        </div>
                    </div>
                </div>

                <div class="table-responsive admission-path-table-wrapper">
                    <table class="table table-sm table-hover mb-0">
                        <thead>
                            <tr>
                                <th>Contacto</th>
                                <th>RUT</th>
                                <th>Carrera</th>
                                <th>Aprobación</th>
                                <th>Notas</th>
                                <th>Mención</th>
                                <th class="text-right">Fecha matrícula</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="via in viasFiltradas" :key="via.hubspot_id">
                                <td>
                                    <strong>{{ via.contact_name || via.dealname }}</strong>
                                    <small class="d-block text-muted">ID {{ via.hubspot_id }}</small>
                                </td>
                                <td>{{ via.rut || '-' }}</td>
                                <td>{{ via.carrera }}</td>
                                <td>{{ via.aprobacion || '-' }}</td>
                                <td class="admission-path-notes-cell">{{ via.notas || '-' }}</td>
                                <td>
                                    <span>{{ via.mencion || '-' }}</span>
                                    <small v-if="via.mencion_campo" class="d-block text-muted">{{ via.mencion_campo }}</small>
                                </td>
                                <td class="text-right">{{ formatShortDate(via.closedate) }}</td>
                            </tr>
                            <tr v-if="!viasFiltradas.length && !cargando">
                                <td colspan="7" class="text-center text-muted py-4">Sin registros</td>
                            </tr>
                            <tr v-if="cargando">
                                <td colspan="7" class="text-center text-muted py-4">Cargando datos desde HubSpot...</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
.admission-path-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
}

.admission-path-filters {
    display: flex;
    gap: 8px;
}

.admission-path-filters .custom-select {
    min-width: 150px;
}

.admission-path-filters .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: calc(1.5em + 0.5rem + 2px);
    line-height: 1;
    white-space: nowrap;
}

.admission-path-filters .btn span,
.admission-path-filters .btn i {
    line-height: 1;
}

.admission-path-notes-cell {
    min-width: 220px;
    max-width: 360px;
    white-space: normal;
}

.admission-path-filter-panel {
    border: 1px solid #e8edf3;
    border-radius: 8px;
    padding: 12px 12px 4px;
    background: #fbfcfe;
}

.admission-path-filter-panel label {
    color: #56657a;
    font-size: 12px;
    font-weight: 600;
}

.admission-path-clear-filter {
    display: flex;
    align-items: flex-end;
}

.admission-path-kpi {
    min-height: 92px;
    border: 1px solid #e8edf3;
    border-radius: 8px;
    padding: 16px;
    background: #fff;
}

.admission-path-kpi span {
    display: block;
    color: #6c757d;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.admission-path-kpi strong {
    display: block;
    margin-top: 8px;
    color: #24364b;
    font-size: 26px;
    line-height: 1.1;
}

.admission-path-kpi-primary {
    border-color: #cfe2ff;
    background: #f7fbff;
}

.admission-path-table-wrapper {
    border: 1px solid #e8edf3;
    border-radius: 8px;
}

@media (max-width: 767.98px) {
    .admission-path-header,
    .admission-path-filters {
        display: block;
    }

    .admission-path-filters .custom-select {
        width: 100%;
        margin-top: 8px;
    }

    .admission-path-filters .btn {
        width: 100%;
        justify-content: center;
        margin-top: 8px;
    }

    .admission-path-clear-filter {
        display: block;
    }
}
</style>